<p-confirmdialog />
<p-toast key="global"></p-toast>
<div
  class="flex justify-center flex-col md:flex-row gap-5"
  style="min-height: 81vh"
  *ngIf="linkApplicationEnabled()"
>
  <div class="card documents-card">
    <div>
      <h1
        class="text-center text-4xl font-circe font-semibold text-primary mt-24"
      >
        Mes Documents
      </h1>

      <div class="text-center mt-10">
        <button
          pButton
          pRipple
          type="button"
          (click)="showModal()"
          icon="pi pi-folder-plus"
          label="Déposer un document"
          class="p-button p-button-contrast mb-4"
          severity="contrast"
          [disabled]="hasNoExternalLinks()"
        ></button>
        <br />
        <i *ngIf="hasNoExternalLinks()" class="text-red-700"
          >Avant de déposer un document, il est nécessaire de rattacher votre
          espace bénéficiaire aux logiciels de suivi, via le bouton "Lier mon
          dossier" présent dans le menu.</i
        >
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-11 my-10 sm:m-10">
      <div class="col-span-1 sm:col-span-5">
        <div class="px-0 sm:px-6 py-4">
          <h1 class="text-xl text-center font-circe mb-5 text-primary">
            {{ "documents.envoyesTitle" | translate }}
          </h1>
          <p class="text-base font-circe">
            {{ "documents.envoyesDescription" | translate }}
          </p>

          <div class="mt-10 grid gap-4">
            <div
              *ngFor="let docEnvoye of documentsEnvoyes()"
              class="card flex flex-col gap-2 !mb-0"
            >
              <div class="flex justify-between items-center">
                <div class="text-base font-semibold doc-title-ellipsis">
                  {{ docEnvoye.nom }}
                </div>
                <div class="flex items-center gap-1 text-base font-semibold">
                  <i
                    *ngIf="docEnvoye.retentionRequired"
                    pTooltip="Ce document n'est plus supprimable car il est utilisé dans les démarches par notre intervenant"
                    class="pi pi-info-circle"
                  ></i>
                  <button
                    *ngIf="!docEnvoye.retentionRequired"
                    class="text-red-500 hover:text-red-700"
                    style="font-size: 1.5rem"
                    (click)="confirmDelete(docEnvoye.id)"
                  >
                    <i
                      pTooltip="Supprimer le document"
                      class="pi pi-trash"
                      style="font-size: 1.5rem"
                    ></i>
                  </button>
                </div>
              </div>
              <div
                class="flex flex-col sm:flex-row justify-between items-start sm:items-center text-sm font-light"
              >
                <div>
                  <span
                    >Transmis le :
                    {{ docEnvoye.createdDate | date : "dd/MM/yyyy" }}</span
                  ><br />
                  <u>Logiciel :</u> {{ docEnvoye.externalAppTitle }}
                </div>
                <button
                  pButton
                  pRipple
                  type="button"
                  (click)="askDownload(docEnvoye.id)"
                  icon="pi pi-download"
                  label="Télécharger"
                  class="p-button p-button-success mt-4 sm:mt-0 sm:ml-4"
                  severity="success"
                ></button>
              </div>
            </div>

            <div
              *ngIf="documentsEnvoyes()?.length == 0"
              class="card flex flex-col gap-2 !mb-0"
            >
              <div class="text-base font-semibold">
                {{ "documents.zeroDocumentsEnvoyesTitle" | translate }}
              </div>
              <i class="text-sm font-light"
                >{{ "documents.zeroDocumentsEnvoyesDescription" | translate }}
              </i>
            </div>
          </div>
        </div>
      </div>

      <div class="block sm:hidden my-4">
        <hr class="border border-surface-200 mx-8" />
      </div>
      <div class="hidden sm:flex justify-center h-screen">
        <div class="w-0.5 h-full border border-surface-200"></div>
      </div>

      <div class="col-span-1 sm:col-span-5">
        <div class="px-0 sm:px-6 py-4">
          <h1 class="text-xl text-center font-circe mb-5 text-primary">
            {{ "documents.recusTitle" | translate }}
          </h1>
          <p class="text-base font-circe">
            {{ "documents.recusDescription" | translate }}
          </p>

          <div class="mt-10 grid gap-4">
            <div
              *ngFor="let docRecu of documentsRecus()"
              class="card flex flex-col gap-2 !mb-0"
            >
              <div class="flex justify-between items-center">
                <div class="text-base font-semibold doc-title-ellipsis">
                  {{ docRecu.nom }}
                </div>

                <div
                  class="flex items-center gap-1 text-base font-semibold"
                ></div>
              </div>
              <div
                class="flex flex-col sm:flex-row justify-between items-start sm:items-center text-sm font-light"
              >
                <div>
                  <span
                    >Transmis le :
                    {{ docRecu.createdDate | date : "dd/MM/yyyy" }}</span
                  ><br />
                  <u>Logiciel :</u> {{ docRecu.externalAppTitle }}
                </div>
                <button
                  pButton
                  pRipple
                  type="button"
                  (click)="askDownload(docRecu.id)"
                  icon="pi pi-download"
                  label="Télécharger"
                  class="p-button p-button-success mt-4 sm:mt-0 sm:ml-4"
                  severity="success"
                ></button>
              </div>
            </div>
            <div
              *ngIf="documentsRecus()?.length == 0"
              class="card flex flex-col gap-2 !mb-0"
            >
              <div class="text-base font-semibold">
                {{ "documents.zeroDocumentsRecusTitle" | translate }}
              </div>
              <i class="text-sm font-light">
                {{ "documents.zeroDocumentsRecusDescription" | translate }}
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-create-document-dialog
  [(visible)]="displayModal"
  (created)="onCreated($event)"
  (cancelled)="onCancelled()"
/>

<p-dialog
  [(visible)]="displayOtpModal"
  [modal]="true"
  [closable]="true"
  (onHide)="displayOtpModal = false"
  [breakpoints]="{ '1199px': '80vw', '700px': '90vw' }"
  [style]="{ width: '50vw' }"
>
  <ng-template pTemplate="header">
    <h3>Vérification du code reçu</h3>
  </ng-template>

  <p-message severity="success"
    >Nous vous avons envoyé votre code par sms au numéro suivant : {{ documentTel }}. Merci de le
    saisir ci-dessous puis cliquer sur Valider.</p-message
  >

  <p-message *ngIf="errorMessage" severity="error">{{
    errorMessage
  }}</p-message>

  <div class="flex flex-col gap-4 items-center justify-center py-4">
    <div class="mb-4">
      <p-inputotp
        class="otp-input-row justify-center"
        [(ngModel)]="otpCode"
        [length]="8"
        (ngModelChange)="validatorVerificationCode()"
        (paste)="handlePaste($event)"
      >
        <ng-template #input let-token let-events="events" let-index="index">
          <input
            pInputText
            type="text"
            [maxLength]="1"
            (input)="events.input($event)"
            (keydown)="events.keydown($event)"
            [attr.value]="token"
            class="custom-otp-input"
          />
          <div *ngIf="index === 4" class="otp-separator px-4">
            <i class="pi pi-minus"></i>
          </div>
        </ng-template>
      </p-inputotp>
    </div>
    <div class="flex justify-center w-full mt-2">
      <button
        pButton
        pRipple
        type="button"
        label="Valider"
        class="p-button p-button-success"
        [disabled]="!validatorVerificationCode()"
        (click)="validateAndStoreDownloadToken()"
      ></button>
    </div>
  </div>
</p-dialog>
